<template>
    <div class="copy-api-url">
        <label for="api-url" class="label">API URL</label>
        <div class="input-group">
            <input id="api-url" type="text" :value="fullUrl" readonly class="url-input" />
            <button @click="copyUrl" class="copy-button">
                {{ copied ? 'Copied!' : 'Copy' }}
            </button>
        </div>
    </div>
</template>

<script>

export default {
    name: "CopyApiUrl",
    methods: {
        copyUrl () {
            navigator.clipboard.writeText(this.fullUrl).then(() => {
                this.copied = true
                setTimeout(() => (this.copied = false), 2000)
            })
        }
    },
    computed: {
        fullUrl () {
            return `${this.baseUrl.replace(/\/$/, "")}/${this.apiPath.replace(/^\//, "")}`
        }
    },
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        apiPath: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            copied: false
        }
    }
}
</script>
<style scoped>
.copy-api-url {
    width: 100%;
    margin: 1rem 0;
}

.label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: bold;
}

.input-group {
    display: flex;
    align-items: center;
}

.url-input {
    flex: 1;
    padding: 0.5rem;
    font-size: 0.95rem;
    border: 1px solid #ccc;
    border-radius: 4px 0 0 4px;
    background-color: #f9f9f9;
}

.copy-button {
    padding: 0.5rem 1rem;
    border: none;
    background-color: #007bff;
    color: white;
    font-weight: bold;
    cursor: pointer;
    border-radius: 0 4px 4px 0;
    transition: background-color 0.3s ease;
}

.copy-button:hover {
    background-color: #0056b3;
}
</style>
